import Overview from './overview.vue';
import FullIndex from './full.vue';



export const componentMap = {
    overview: Overview,
    full: FullIndex,
};